var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        viewBox: "0 0 47 46",
        "xml:space": "preserve",
      },
    },
    [
      _c("path", {
        staticStyle: { fill: "#e40089" },
        attrs: {
          d: "M6.1 0h34.7C44.3 0 47 2.7 47 6v34c0 3.3-2.7 6-6.1 6H6.1C2.7 46 0 43.3 0 40V6c0-3.3 2.7-6 6.1-6z",
        },
      }),
      _c("defs", [
        _c("path", {
          attrs: {
            id: "a",
            d: "M6.1 0h34.7C44.3 0 47 2.7 47 6v34c0 3.3-2.7 6-6.1 6H6.1C2.7 46 0 43.3 0 40V6c0-3.3 2.7-6 6.1-6z",
          },
        }),
      ]),
      _c("clipPath", { attrs: { id: "b" } }, [
        _c("use", {
          staticStyle: { overflow: "visible" },
          attrs: { "xlink:href": "#a" },
        }),
      ]),
      _c("g", { staticStyle: { "clip-path": "url(#b)" } }, [
        _c("path", {
          staticStyle: { fill: "#ff45b4" },
          attrs: {
            d: "m-6.2 10.9-53.3 42.7c-1.5 1.2-.6 3.6 1.2 3.6H51.8c1.9 0 2.7-2.4 1.2-3.6L-3.8 10.9c-.7-.6-1.7-.6-2.4 0z",
          },
        }),
        _c("path", {
          staticStyle: { fill: "#f30f98" },
          attrs: {
            d: "M-5.2 28.5-27 45.9c-1.5 1.2-.6 3.6 1.2 3.6h45c1.9 0 2.7-2.4 1.2-3.6L-2.8 28.4c-.7-.5-1.7-.5-2.4.1z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }